module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("￥")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("饭卡余额")]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "right",
    on: {
      "click": function($event) {
        _vm.$emit('charge')
      }
    }
  }, [_c('div', {
    staticClass: "area"
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("充")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_vm._v("充值")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a07d10c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/charge.vue
// module id = 881
// module chunks = 34